import React, { memo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import styles from './footerActions.module.scss';

import SupportConnection from '../SupportConnection/SupportConnection';

const conditionalStyles = classNames.bind(styles);

export default memo(withRouter(function FooterActions(props) {
    const [t] = useTranslation('auth');

    const url = props.location.pathname.endsWith('/') ? 'check-username' : '/check-username';

    const backToNonAdminLogin = () => props.history.push('/signin');

    return (
        <div className={styles.actionsContainer}>
            <div className={styles.lineContainer}>
                <hr />
            </div>
            <div
                className={conditionalStyles({
                    actions: true,
                    singleAction: props.location.pathname !== '/signin/admin',
                    multipleActions: props.location.pathname === '/signin/admin'
                })}
            >
                <Link to={`${props.location.pathname}${url}`}>{t('FORGOT_PASSWORD')}</Link>
                {
                    props.location.pathname === '/signin/admin' &&
                    <div className={styles.iconActions}>
                        <SupportConnection />
                        <div onClick={backToNonAdminLogin} className={styles.iconContainer}>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/general.svg" />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}));
